import React, { useState } from "react";
import {
  Button,
  Segment,
  Container,
  Header,
  Menu,
  Input,
  Divider,
} from "semantic-ui-react";
import { faArrowRight, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import ServiceNotification from "../../core/services/services.notification";

const ChatRoomList = () => {
  const navigate = useNavigate();
  const [joinLink, setJoinLink] = useState("");

  const createRoom = () => {
    const roomId = uuidv4();
    navigate(`/chat/${roomId}?host=true`);
  };

  const joinRoom = () => {
    if (!joinLink.trim()) {
      ServiceNotification.show("", "لینک چت را وارد کنید.", "danger");
      return;
    }
    window.location.href = joinLink.trim();
    // navigate(joinLink.trim());
  };

  return (
    <>
      <Menu className="psubHeader">
        <Container fluid>
          <Button
            basic
            className="transparentBtn"
            onClick={() => {
              navigate("/");
            }}
          >
            <FontAwesomeIcon icon={faArrowRight} />
          </Button>
          <Header className="pageHeader">چت لحظه ای</Header>
          <Menu.Item position="right" className="p-0"></Menu.Item>
        </Container>
      </Menu>
      <Segment basic className="m-2-b">
        <Container fluid>
          <div style={{ maxWidth: "50vw", margin: "auto" }}>
            <Button size="small" primary onClick={createRoom}>
              <FontAwesomeIcon icon={faPlus} /> &nbsp; ایجاد چت جدید
            </Button>
            <Divider />
            <Input
              size="small"
              fluid
              action={
                <Button size="small" primary onClick={joinRoom}>
                  ورود به چت
                </Button>
              }
              value={joinLink}
              onChange={(e) => setJoinLink(e.target.value)}
              placeholder="لینک چت را وارد کنید."
            />
          </div>
        </Container>
      </Segment>
    </>
  );
};

export default ChatRoomList;
